import React from 'react'
import {useParams} from 'react-router-dom'
import useEffect from 'admin/hooks/useEffect'
import usePaymentDetail from 'admin/hooks/usePaymentDetail'
import useDocument from 'admin/hooks/useDocument'
import useStateObject from 'admin/hooks/useStateObject'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'

export default () => {
  const {organisationID} = useParams()
  const {paymentDetailId, popModal} = useModal()
  const {paymentDetail, errors, update} = usePaymentDetail(organisationID, paymentDetailId)
  const [form, setForm, resetForm] = useStateObject(paymentDetail)

  useDocument({title: `Payment detail ${paymentDetailId}`})

  useEffect(() => setForm(paymentDetail), [paymentDetail], false)

  const handleUpdate = e => {
    e.preventDefault()
    update(form)
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm(paymentDetail)
    popModal('payment-detail', ['paymentDetailId'])
  }

  return (
    <Modal onClose={handleClose} flashId='edit-payment-detail'>
      <Header title='Edit payment detail'>
        <button className='button is-success' onClick={handleUpdate}>
          Save
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <InputField
            type='text'
            name='name'
            label='Name'
            value={form.name || ''}
            onChange={setForm}
            errors={errors.name}
          />
          <InputField
            type='textarea'
            name='contentWithPlaceholders'
            label='Content'
            value={form.contentWithPlaceholders || ''}
            onChange={setForm}
            errors={errors.contentWithPlaceholders}
            rows={10}
          />
        </div>
      </section>
    </Modal>
  )
}
